import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import styles from '../../QuestionDisplay.scss';
import utilService from '../../../../services/UtilService';
import constants from '../../../../qti/Constants';
import imageSelector from '../../../../selectors/question/media/image/ImageSelector';
import themeServices from '../../../../themes/ThemeServices';

const ImageContent = (props) => {
    const {
        autoScale,
        classList,
        contentId,
        extraProps = {},
        imageAlt,
        initialStyle,
        model,
        onErrorCallback = null,
        onLoadCallback = null,
        recommendedMaxHeight,
        reportReady,
        shouldAddAlignStyle,
        shouldScaleImage,
        src,
    } = props;

    const { align, isMainMedia, maxHeight } = model;
    let timeout;

    const [imageStyle, setImageStyle] = useState(initialStyle);

    const getClassName = () => {
        return (shouldAddAlignStyle) ? `${classList} ${styles[align]}` : classList;
    };

    const onLoad = () => {
        utilService.callAfterAnimationFrames(onRendered);
        if (onLoadCallback) {
            onLoadCallback();
        }
    };

    useEffect(() => {
        return function cleanup() {
            if (timeout) {
                clearTimeout(timeout);
            }
        };
    });

    const onError = () => {
        if (onErrorCallback) {
            onErrorCallback();
        }
    };

    const onRendered = () => {
        resetDimensionStyles();
        reportReady(true);

        if (shouldScaleImage) {
            themeServices.getThemeInstance().scaleImage(contentId);
        }
    };

    const onDragStart = (event) => {
        event.preventDefault();
        return false;
    };

    const resetDimensionStyles = () => {
        if (isMainMedia) {
            timeout = setTimeout(() => {
                const style = { maxWidth: '100%' };
                if (maxHeight !== constants.maxHeightOptions.NONE) {
                    style.maxHeight = `${recommendedMaxHeight}px`;
                }
                setImageStyle(style);
            }, 1000);
        }
    };

    return (
        <img
            {...extraProps}
            alt={imageAlt}
            data-content-id={contentId}
            className={getClassName()}
            src={src}
            style={autoScale ? null : imageStyle}
            onDragStart={onDragStart}
            onError={onError}
            onLoad={onLoad}
        />
    );
};

ImageContent.propTypes = {
    autoScale: PropTypes.bool,
    classList: PropTypes.string,
    contentId: PropTypes.string.isRequired,
    extraProps: PropTypes.object,
    imageAlt: PropTypes.string.isRequired,
    initialStyle: PropTypes.object,
    model: PropTypes.object.isRequired,
    onErrorCallback: PropTypes.func,
    onLoadCallback: PropTypes.func,
    questionObjectType: PropTypes.string,
    recommendedMaxHeight: PropTypes.number.isRequired,
    reportReady: PropTypes.func.isRequired,
    shouldAddAlignStyle: PropTypes.bool.isRequired,
    shouldScaleImage: PropTypes.bool.isRequired,
    src: PropTypes.string.isRequired,
    useModelWidthAndHeight: PropTypes.bool,
};

const Image = props => (
    <ImageContent {...props} {...imageSelector.selectProps(props)} />
);

export default Image;
